import { useQuery } from 'react-query';
import { historiesApi } from '../../../../API/TT_ELD/Team/histories';

export const useHistories = (
  driverId: string | number,
  editedById: string | number,
  companyId: string | number,
  skip: number,
  model: string,
  status: string,
  type?: string,
) => {
  return useQuery(
    [`histories/${driverId}`, driverId, editedById, companyId, skip, model, status, type],
    () => historiesApi.read(driverId, editedById, companyId, skip, model, status, type),
    { refetchOnWindowFocus: false },
  );
};

export const useHistoryModels = () => {
  return useQuery(['history-models'], () => historiesApi.getHistoryModels(), {
    refetchOnWindowFocus: false,
  });
};
